import { search } from "./search.reducer";
import { searchField } from "./searchField.reducer";
import { mobileMenu } from "./mobileMenu.reducer";
import { languageField } from "./languageField.reducer";
import { cookiebar } from './cookiebar.reducer';

export default {
  search,
  searchField,
  mobileMenu,
  languageField,
  cookiebar
};
